// extracted by mini-css-extract-plugin
export var bigHoverActionButton = "mGATq";
export var bigHoverActionContainer = "QpoLy";
export var bigHoverActionContainer_Deprecated = "GW62o";
export var mclBigHover = "gJ512";
export var mclCompact = "MInNE";
export var sclBigHoverActionButton = "d7bfX";
export var sclCompact = "tkmTs";